import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const wifi = {
    getDataAnalytics,
    addWifiAuthenticate,
    pollInternetStatus
}

async function addWifiAuthenticate({
    mac_address,
    estimation_id,
    site_id
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/wifi/authorization',
            body: {
                mac_address,
                estimation_id,
                site_id
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception orderProvisioning: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getDataAnalytics({
    organisation_id
} = {}) {
    try {
        if(!organisation_id) organisation_id = httpUtil.getSession().current_organisation_id;
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/estimates/allowance',
            body: {
                contact_id: id,
                organisation_id: organisation_id
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception orderProvisioning: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function pollInternetStatus() {
    try {
        let options = { method: "GET" };
        let response = await fetch('http://worldtimeapi.org/', options);
        if (response.status == '200')
            return 0;
        else {
            response = await fetch('https://google.com/', options);
            if (response.status == '200')
                return 0;
            return -2;
        }

    } catch (e) {
        console.log('pollInternetStatus: ', e);
        return -1;
    }
}




